export default __webpack_public_path__ + "static/media/invoice.48137862.svg";